<div class="container-fluid">
  <div class="row">
    <div class="col-xl-12">
      <h1 class="page-hd">Document Verification</h1>
      <div class="content-wrap">
        <div class="table-responsive">
          <table class="ui celled table hover" id="example" [dtTrigger]="dtTrigger" datatable [dtOptions]="dtOptions">
            <thead>
              <tr>
                <th *ngIf="hideId">Id</th>
                <th>Student Name</th>
                <th>Seat No.</th>
                <!-- <th>Passing Month</th> -->
                <th>Passing Year</th>
                <th>Stream</th>
                <th>Branch</th>
                <th>Semester</th>
                <th>Document</th>
                <!-- <th>Request Type</th> -->
                <th>Days Remaining</th>
                <th>Status</th>
                <th>Remark</th>
                <th>Preview Document</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of request">
                <td *ngIf="hideId">{{data.id}}</td>
                <td>{{data.fullName}}</td>
                <td> {{data.enrollmentNo}} </td>
                <!-- <td>{{data.monthOfPassing}}</td> -->
                <td>{{data.monthOfPassing}}/{{data.yearofPassing}}</td>
                <td>{{data.stream}}</td>
                <td>{{data.branch_nm}}</td>
                <td>{{data.semester}}</td>
                <td>{{data.docName}}</td>
                <!-- <td>Express <span class="req_date">17 Feb 2020</span></td> -->
                <td>{{data.noOfDays}}</td>
                <td>{{data.status}}</td>

                <td><button class='action-btn bg-theme' data-toggle="modal" data-target="#remarkDetails"
                  (click)="showRemark(data.remark, data.id)">View</button>
                </td>
                <td>
                  <!-- <button class='action-btn bg-theme' data-toggle="modal" data-target="#viewModal"
                    (click)="openModal(data.id)">View</button> -->
                  <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal"
                    (click)="openModal(data.id)">View</button>
                </td>
              </tr>
            </tbody>
          </table>
          <pdf-viewer [src]="src" [zoom]="1" hidden></pdf-viewer>
          <pdf-viewer [src]="src1" [zoom]="1" hidden></pdf-viewer>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="viewModal" #viewModalBox tabindex="-1" role="dialog" aria-labelledby="viewModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>
        <button type="button" #closebutton class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <p class="doc-txt">To be verified</p>
            <!-- <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)"> -->
            <div *ngIf="isVrPdf">
              <div class="ng-star-inserted22">
                <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
              </div>
              <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
            </div>
            <div *ngIf="isVrImage">
              <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)" loading="lazy">
            </div>
          </div>
          <div class="col-md-6">
            <p class="doc-txt">System document</p>
            <div *ngIf="isUPdf">
              <div class="ng-star-inserted22">
                <pdf-viewer [src]="src1" [zoom]="1"></pdf-viewer>
              </div>
              <button class="new-tab-btn" (click)="openPdf1()">Open Doc in Browser</button>
            </div>
            <div *ngIf="isUImage">
              <img src={{originalDocUploadFilePath}} class="doc-img" (click)="showLightbox(1)" loading="lazy">
            </div>
          </div>
        </div>
        <!-- <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved"
          (click)="changeStatus($event)">Positive</button> -->
        <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved_Pass"
          (click)="changeStatus($event)">Match and Pass</button>
        <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved_Fail"
          (click)="changeStatus($event)">Match and Fail</button>
        <button class="reject-modal-btn mr-auto" data-toggle="modal" name="UN_Rejected" data-target="#rejectModal"
          (click)="openRemarkModal($event)">Negative</button>
          <!-- <button class="approve-modal-btn bg-theme mr-auto" data-toggle="modal" name="Ver_Request_Edit" data-target="#editReasonModal"
          (click)="fetchEditReason($event)">Send To edit</button> -->
      </div>
    </div>
  </div>
</div>

<ng-template #showModalBoxImage let-modal>
  <div class="modal-content">
    <div class="modal-header bg-theme">
      <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-6">
          <div *ngIf="!isVrPdf && !noImage1">
            <app-magnify [imageId]="imgname" [ImageURL]="upload_doc_path"> </app-magnify>
          </div>

          <p class="doc-txt">To be verified</p>
          <!-- <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)"> -->
          <div *ngIf="isVrPdf">
            <div class="ng-star-inserted22">
              <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
            </div>
            
            <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
            <button class="approve-modal-btn bg-theme mr-auto ml-2" (click)="fetchRejectionTrail()">Rejection Trail</button>
          </div>
          <div *ngIf="isVrImage">
            <!-- <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)" loading="lazy"> -->

            <div class="img-magnifier-container">
              <img src={{upload_doc_path}} class="doc-img" id="uploadImg1" (click)="showLightbox(0)" loading="lazy">
            </div>
            <button class="approve-modal-btn bg-theme mr-auto rej-button" (click)="fetchRejectionTrail()">Rejection Trail</button>
          </div>
        </div>
        <div class="col-md-6">
          <div *ngIf="!isUPdf && !noImage2">
            <app-magnify [imageId]="imgname2" [ImageURL]="originalDocUploadFilePath"> </app-magnify>
          </div>
          <p class="doc-txt">System document</p>
          
          <div *ngIf="isUPdf">
            <div class="ng-star-inserted22">
              <pdf-viewer [src]="src1" [zoom]="1"></pdf-viewer>
            </div>
            
            <button class="new-tab-btn" (click)="openPdf1()">Open Doc in Browser</button>
          </div>
          <div *ngIf="isUImage">
            <!-- <img src={{originalDocUploadFilePath}} class="doc-img" (click)="showLightbox(1)" loading="lazy"> -->
            <div class="img-magnifier-container">
              <img src={{originalDocUploadFilePath}} class="doc-img" id="uploadImg2" (click)="showLightbox(1)"
                loading="lazy">
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <label for="password" class="form-label">Mode of study</label>
              <select class="form-control form-input" [(ngModel)]="modeOfStudy" (change)="getModeOfStudy($event)">
                <option value="Regular">Regular</option>
                <option value="Distance">Distance</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved"
        (click)="changeStatus($event)">Positive</button> -->
      <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved_Pass"
        (click)="changeStatus($event)">Match and Pass</button>
      <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved_Fail"
        (click)="changeStatus($event)">Match and Fail</button>
      <button class="reject-modal-btn mr-auto" data-toggle="modal" name="UN_Rejected" data-target="#rejectModal"
        (click)="openRemarkModal($event)">Negative</button>
        <button class="approve-modal-btn bg-theme mr-auto rej-button" data-toggle="modal" name="Uni_Request_Edit" data-target="#editReasonModal"
        (click)="fetchEditReason($event)">Reject</button>
    </div>
  </div>

</ng-template>

<ng-template #showRejectionTrailBox let-modal>
  <div class="modal-content">
    <div class="modal-header bg-theme">
      <h5 class="modal-title" id="viewModalLabel">Rejection Trail</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="table-fixed-ht">
      <div class="table-responsive">
        <table class="ui celled table hover cust-table">
          <thead>
            <th>Role</th>
            <th>Date</th>
            <th>Reject Reason</th>
          </thead>
          <tbody>
            <tr *ngIf="!rejectionTrail">
              <td>No data found</td>
            </tr>
            <tr *ngFor="let data of rejectionTrail">
              <td>{{data.role}}</td>
              <td>{{data.date}}</td>
              <td>{{data.reason}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>

<div class="modal fade" id="editReasonModal" tabindex="-1" role="dialog" aria-labelledby="editReasonModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="editReasonModalLabel">Reason For Edit</h5>
        <button type="button" #closebuttonRemark class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="EditReasonForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">
                <label for="editReasonVal" class="form-label">Edit Reason<span class="color-red">*</span></label>
                <textarea placeholder="Enter your reason" [(ngModel)]="editReasonVal" class="form-control form-input"
                  id="editReasonVal" formControlName="editReasonVal"
                  [ngClass]="{'is-invalid': submitted4 && i.editReasonVal.errors }"></textarea>
                <div *ngIf="submitted4 && i.editReasonVal.errors" class="invalid-feedback">
                  <div *ngIf="i.editReasonVal.errors.required">Reason is required</div>
                </div>
              </div>


            </div>
          </div>
        </form>
        <button class="approve-modal-btn bg-theme mr-auto" name="Ver_Request_Edit"
          (click)="changeEditStatusWithReason($event)">Submit</button>
        <button class="reject-modal-btn mr-auto" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="rejectModal" tabindex="-1" role="dialog" aria-labelledby="rejectModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="rejectModalLabel">Remark</h5>
        <button type="button" #closebuttonRemark class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="RemarkForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">

                <label for="reasonVal" class="form-label">Remark<span class="color-red">*</span></label>
                <textarea placeholder="Enter your remark" [(ngModel)]="reasonVal" class="form-control form-input"
                  id="reasonVal" formControlName="reasonVal"
                  [ngClass]="{'is-invalid': submitted && f.reasonVal.errors }"></textarea>
                <div *ngIf="submitted && f.reasonVal.errors" class="invalid-feedback">
                  <div *ngIf="f.reasonVal.errors.required">Remark is required</div>
                </div>

              </div>
            </div>
          </div>
        </form>
        <button class="approve-modal-btn bg-theme mr-auto" name="UN_Rejected"
          (click)="changeRemarkStatus($event)">Submit</button>
        <button class="reject-modal-btn mr-auto" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
  let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

  <div class="modal-content">
    <div class="modal-header success-modal-header">
      <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
        <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>

      </h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h3 class="success-text">Success</h3>
          <p class="reset-hd2">Status has been updated.</p>
        </div>
      </div>
      <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
    </div>
  </div>
</ng-template>

<div class="modal fade" id="remarkDetails" tabindex="-1" role="dialog" aria-labelledby="remarkModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="remarkModalLabel">Remark Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group input-group-lg">
              <span class="appId">{{remark}} </span>
            </div>
          </div>
        </div>

        <form [formGroup]="NewRemarkForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">

                <label for="newReasonVal" class="form-label">Remark</label>
                <textarea placeholder="Enter your comment" [(ngModel)]="newReasonVal" class="form-control form-input"
                  id="newReasonVal" formControlName="newReasonVal"></textarea>
              </div>
            </div>
          </div>
        </form>
        <button class="approve-modal-btn bg-theme mr-auto"
          (click)="addNewRemark($event)" data-dismiss="modal">Submit</button>
        <button class="reject-modal-btn mr-auto" data-dismiss="modal">Cancel</button>

      </div>
    </div>
  </div>
</div>


<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<ng-image-fullscreen-view [images]="imageObject" [imageIndex]="selectedImageIndex" [show]="showFlag"
  (close)="closeEventHandler()">
</ng-image-fullscreen-view>